export default "__VITE_ASSET__6ad85c74__"